import { useObserver } from "mobx-react";
import ScoreCard from "./scoreCard";
import { useStores } from "../../../store";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../reusble_components/loader";
import { MdDeleteOutline, MdOutlineArrowBack } from "react-icons/md";
import { AiOutlineCloseCircle, AiOutlineFilePdf } from "react-icons/ai";
import PdfViewer from "../../reusble_components/pdfViewer";

// Reusable Section Component
const Section = ({ title, items, textColor, bgColor, borderColor }) => {
  return (
    <div className={`${bgColor} ${textColor} py-3 md:py-6 px-6 md:px-12 `}>
      <h3 className="font-semibold text-lg">{title}</h3>
      <ul className="mt-2 space-y-2">
        {items?.map((text, index) => (
          <li
            key={index}
            className={`border-l ${borderColor} text-[#747474]  pl-3 text-sm md:text-base`}
          >
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default function Report() {
  const { UserStore, CommonStore } = useStores();
  const [loader, setLoader] = useState(false);
  const [reportLoader, setReportLoader] = useState(false);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id");
  useEffect(() => {
    const fetchReport = async () => {
      setLoader(true);
      await UserStore.fetchResumeReportById(id);
      setLoader(false);
    };

    fetchReport();

  }, [id]);

  const getList = (items, key) => {
    let list;
    items?.map((item, index) => {
      if (item.name === key) {
        list = item.points;
      }
    });
    return list;
  };

  useEffect(() => {
    return () => {
      // Reset the resume report state when the component unmounts
      UserStore.resumeReport = null;
    };
  }, [UserStore]);
  const navigation = useNavigate();

  return useObserver(() => (
    <>
      {loader ? (
        <Loader loader={loader} />
      ) : (
        <div className="w-full  px-4 md:px-10 py-4 my-20 md:my-0   mx-auto">
          {CommonStore.resume && (
            <PdfViewer
              pdfUrl={CommonStore.jobresume}
              onClose={() => CommonStore.setResume(false)}
            />
          )}
          {id && (
            <h1 className="text-primary text-2xl font-bold border-b border-[#ccdod6] py-6 md:py-8 mb-4 px-2  ">
              Resume Analyzer
            </h1>
          )}
          <Loader loader={reportLoader && id} />
          {id && (
            <button
              onClick={() => {
                navigation("/dashboard/resume-analyzer");
              }}
              className=" text-md font-bold  mb-4 px-2 flex items-center gap-2 "
            >
              <MdOutlineArrowBack /> Back
            </button>
          )}
          {id && (
            <h1 className=" text-lg font-bold   mb-4 px-2  ">
              {UserStore?.resumeReport?.name} 
            </h1>
          )}
          <div className="flex justify-between w-full items-center ">
            <h1 className="text-primary font-bold pb-4 text-xl pl-2">
              Your Report
            </h1>
            {id && (
              <span className="  text-sm flex gap-4 items-center text-[#747474]">
                <button
                  className="flex items-center gap-2"
                  onClick={() => {
                    CommonStore.setJobResume(UserStore?.resumeReport?.resume);
                    CommonStore.setResume(true);
                  }}
                >
                  <AiOutlineFilePdf />
                  <span className="hidden md:block">
                    {UserStore?.resumeReport?.resume
                      ? UserStore?.resumeReport?.resume?.split("/").pop()
                      : "Resume"}
                  </span>
                </button>
                <button
                  className="flex items-center gap-2"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Are you sure you want to delete this report?"
                      )
                    ) {
                      setReportLoader(true);
                      UserStore.deleteResume(UserStore?.resumeReport?._id);
                      navigation("/dashboard/resume-analyzer");
                      setReportLoader(false);
                    }
                  }}
                >
                  <MdDeleteOutline />
                  <span className="hidden md:block">Delete Report</span>
                </button>
              </span>
            )}
            {!id && (
              <span className="  text-sm flex gap-4 items-center text-[#747474]">
                <button
                  className="flex items-center gap-2"
                  onClick={(e) => {
                    UserStore.resumeReport = null;
                    UserStore.getAllPreviousResumes();
                  }}
                >
                  <AiOutlineCloseCircle />
                  Close Report
                </button>
              </span>
            )}
          </div>
          {/* Score Card Section */}
          <div className="bg-[#FEF4EE]">
            <ScoreCard
              title={`Your resume scored ${UserStore?.resumeReport?.score} / 100.`}
              description={
                UserStore?.resumeReport?.scoreDescription ??
                UserStore?.resumeReport?.suggestion
              }
              percentage={UserStore?.resumeReport?.score}
            />
          </div>

          {/* Mistakes Section */}
          <Section
            title="Where did you go wrong?"
            items={getList(UserStore.resumeReport?.feedBack, "Mistakes")}
            textColor="text-[#FF6B00]"
            bgColor="bg-[#FEF4EE] border-b-2 border-dashed"
            borderColor="border-[#FF6B00]"
          />

          {/* Positives Section */}
          <Section
            title="Where did you go right?"
            items={getList(UserStore.resumeReport?.feedBack, "Strengths")}
            textColor="text-[#20BF55]"
            bgColor="bg-[#EAFFF1] border-b-2 border-dashed"
            borderColor="border-[#20BF55]"
          />

          {/* Suggestions Section */}
          <Section
            title="Suggestions"
            items={getList(UserStore.resumeReport?.feedBack, "Suggestions")}
            textColor="text-[#0077FF]"
            bgColor="bg-[#EDF5FE] rounded-b-2xl md:rounded-b-2xl"
            borderColor="border-[#0077FF]"
          />
        </div>
      )}
    </>
  ));
}
